// Generate styles for a pseudo ::after element that will be wide enough for bold text,
// so the parent element layout doesn't grow bigger if its text is made bold.
export const getBoldFixStyles = (text) => ({
    content: `"${text}"`,
    display: "block",
    height: 0,
    visibility: "hidden",
    overflow: "hidden",
    userSelect: "none",
    pointerEvents: "none",
    fontWeight: 500,
    "@media speech": {
        display: "none",
    },
});
/**
 * Accessibility function added to support onKeyDown events. If a control is not a button
 * but has an onClick handler, it also needs an onKeyDown handler that should only act if the
 * key is Enter or Space. This function will check for the appropriate keys and if it receives
 * them, will call the specified function. Other keystrokes (such as tab) are ignored
 *
 * @param event The event received by onKeyDown
 * @param functionToCall     The function to call if the key that was pressed indicates an action
 */
export const actOnEnterOrSpace = (event, functionToCall) => {
    if (event.key === "Enter" || event.key === " ")
        functionToCall();
};
/**
 * Given a string - replace spaces with separator, removes all non-alpha char, and converts string to lowercase
 * @param label Value to convert into slug. If undefined, returns empty string
 * @param separator: Optional - string char to replace spaces. Default is "-"
 * @returns
 */
export const slugify = (label, separator = "-") => {
    if (!label)
        return "";
    return label
        .toLowerCase()
        .replace(/[^a-z ]/gi, "") // remove any non-alpha chars except for spaces
        .replace(/[ /-]+/gi, separator); // replace one or more spaces with the separator
};
